import { GetServerSidePropsContext, NextPage } from 'next';
import { getPostBySlug } from '../../lib';
import PostPage from '../../templates/post.template';
import { PostProps } from '../../types/post-props.interface';

interface Props extends PostProps { }

const DiscoveriesPage: NextPage<Props> = (props) => {
  return <PostPage {...props} />;
};

export async function getServerSideProps(props: GetServerSidePropsContext) {
  const slug = props.params?.project ?? '';
  const { posts, menu, options } = await getPostBySlug(slug as string);
  if (!posts.length) {
    return {
      notFound: true,
    };
  }

  props.res.setHeader('Cache-Control', 'public, max-age=300, s-maxage=300');

  return { props: { post: posts[0], menu, options } };
}

export default DiscoveriesPage;
